export interface ParsedCoords {
  lat: number;
  lng: number;
}

export function parseCoordsPaste(raw: string): ParsedCoords | null {
  const trimmed = raw.trim();
  const parts = trimmed.split(',').map((p) => p.trim());
  if (parts.length !== 2) return null;
  const lat = Number(parts[0]);
  const lng = Number(parts[1]);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat < -90 || lat > 90) return null;
  if (lng < -180 || lng > 180) return null;
  return { lat, lng };
}
